import { useSocialIndex } from "./useSocialIndex";
import { useTranslation } from "react-i18next";

export function useYouTubeIndex() {
  const { t } = useTranslation();

  const indexingMessages = [
    t("account_indexing.youtube.checking"),
    t("account_indexing.youtube.analyzing"),
    t("account_indexing.youtube.gathering_insights"),
    t("account_indexing.youtube.learning_audience"),
    t("account_indexing.youtube.organizing"),
    t("account_indexing.youtube.finalizing")
  ];

  return useSocialIndex({
    triggerEndpoint: '/api/youtube/index-youtube',
    statusEndpoint: '/api/youtube/social-fetch-status',
    events: {
      startedEvent: 'youtube-index-triggered',
      completedEvent: 'youtube-index-completed',
    },
    indexingMessages,
    startToast: 'YouTube data indexing has begun. This may take a few minutes.',
    completeToast: 'YouTube indexing completed. Redirecting to chat...',
    redirectToChatOnSuccess: true,
  });
}
